<script setup>
    import { computed, onMounted, ref, watch } from 'vue'

    const props = defineProps({
        modelValue: {
            type: Array,
            required: true
        },
        componentId: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        textKey: {
            type: String,
            required: true
        },
        valueKey: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: () => ''
        },
        sortFunction: {
            type: Function,
            default: () => null
        },
        sortKey: {
            type: String,
            default: () => 'kurzName'
        },
        size: {
            type: String,
            default: () => 'sm'
        }
    })

    const emit = defineEmits(['update:modelValue'])
    const selectedOption = ref([])

    watch(selectedOption, (newValue) => {
        emit('update:modelValue', newValue)
    })

    watch(
        () => props.modelValue,
        (newValue) => {
            selectedOption.value = newValue
        }
    )

    onMounted(() => {
        selectedOption.value = props.modelValue
    })

    const sortFn = computed(() =>
        props.sortFunction
            ? props.sortFunction
            : (options) =>
                  options.every((option) => option.hasOwnProperty(props.sortKey))
                      ? options.sort((a, b) => {
                            if (a[props.sortKey] < b[props.sortKey]) {
                                return -1
                            }
                            if (a[props.sortKey] > b[props.sortKey]) {
                                return 1
                            }
                            return 0
                        })
                      : options
    )

    const mappedOptions = computed(() =>
        [...props.options].sort(sortFn.value).map((option) => {
            return {
                value: option[props.valueKey],
                text: option[props.textKey]
            }
        })
    )
</script>

<template>
    {{ title }}
    <v-chip-group v-model="selectedOption" column multiple>
        <v-chip
            v-for="mappedOption in mappedOptions"
            :key="`${props.title}-${props.componentId}-checkbox-group`"
            :value="mappedOption.value"
            filter
            color="primary"
            >{{ mappedOption.text }}</v-chip
        >
    </v-chip-group>
</template>

<style scoped></style>
